import { post, get, put } from "../api.helper/root";
import { IUpdateTenantPayload } from "@/types/tenant";

const tenantUri = process.env.VUE_APP_TENANT_BASE_URL;

const getPlansUri = tenantUri + "/workspace-setup/plans-list";
const getModulesUri = tenantUri + "/workspace-setup/modules";
const saveTenantUri = tenantUri + "/workspace-setup/save-tenant";
const getTenantInfoUri = tenantUri + "/workspace-setup/tenant-info";
const updateTenantPlanUri = tenantUri + "/workspace-setup";
const getOperationStatusUri = tenantUri + "/operations";

export const getPlans = () => get(getPlansUri);

export const getModules = () => get(getModulesUri);

export const saveTenant = (tenantId: string, userData: IUpdateTenantPayload) =>
  post(`${saveTenantUri}?MCAdminCognitoID=${tenantId}`, userData);

export const getTenantInfo = (tenantId: string) => get(`${getTenantInfoUri}?tenantId=${tenantId}`);

export const updateTenantPlan = (tenantId: string, userData: IUpdateTenantPayload) =>
  put(`${updateTenantPlanUri}/update?tenantId=${tenantId}`, userData);

export const getOperationStatus = (operationId: string) => get(`${getOperationStatusUri}/${operationId}`);